import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './EventDetailsCard.css';
import GradientButton2 from '../ui/GradientButton2/GradientButton2';  
import SoldOutButton from '../ui/SoldOutButton/SoldOutButton';  
import LocationBadge from '../ui/LocationBadge/LocationBadge';
import SpeakerBadge from '../ui/SpeakerBadge/SpeakerBadge';
import VerifiedIcon from './../../assets/icons/ui/verified.svg';
import infoIcon from './../../assets/icons/ui/info.svg';
import { Link } from 'react-router-dom';
import EventTypeBadge from '../ui/EventTypeBadge/EventTypeBadge';
import EventTypeSelection from '../EventTypeSelection/EventTypeSelection';
import SelectPaymentModal from '../SelectPaymentModal/SelectPaymentModal';

interface EventDetailsCardProps {
  date: string;
  time: string;
  title: string;
  speakersName: string;
  speakersLink: string;
  description: string;
  location: string;
  locationLink: string;
  stripeLinkOnline?:string;
  image: string; 
  eventPrice: string;
  priceOfEventOnline?: string;
  buttonText: string;
  onButtonClick: () => void;
  priceOfEventRu?: string;
  priceOfEventRuOnline?: string;
  selectedEventType?: 'inPerson' | 'online';
  stripeLink: string;
  kassaLink?: string;
  eventType: string;
  listOfBenefits: string[];
  isSoldOut?: boolean; // <-- Add this new prop
} 

const EventDetailsCard: React.FC<EventDetailsCardProps> = ({
  date,
  title,
  stripeLinkOnline,
  description,
  image, 
  location, 
  time,
  buttonText,
  speakersName,
  speakersLink,
  locationLink,
  eventPrice,
  kassaLink,
  onButtonClick,
  priceOfEventRuOnline,
  priceOfEventRu,
  priceOfEventOnline,
  stripeLink,
  listOfBenefits,
  eventType,
  isSoldOut = false, // <-- Default to false
}) => {
  const { t } = useTranslation();
  const [selectedEventType, setSelectedEventType] = useState<'inPerson' | 'online'>('inPerson');
  const [showModal, setShowModal] = useState(false);


  return (
    <div className="course-overview-container"> 
      <div className="course-overview-image" style={{ position: 'relative' }}>
        <div className="event-location-badge">
          <EventTypeBadge type={eventType} />
        </div>
        <img src={image} alt="Course" />
      </div>
      
      <div className="course-overview-content">
        <div style={{ display: 'flex', gap: '10px' }}> 
          <p className="course-date">{date} {t("at")} {time}</p> 
          <LocationBadge location={location} link={locationLink} />
        </div>
  
        <SpeakerBadge speakersName={speakersName} link={speakersLink} />
        <h1 className="course-title">{title}</h1>
{stripeLinkOnline &&  <EventTypeSelection
    value={selectedEventType}
    onChange={setSelectedEventType}
  />}
<p className="course-description">{description}</p>

     
        <div className='event-price-container'>
          <div className='price-and-tool-tip'>
            <div>
            <p className="event-price-description">
  {selectedEventType === 'online'
    ? priceOfEventRuOnline || t("price_for_event")
    : priceOfEventRu || t("price_for_event")}
</p>

<h2 className="event-price">
  {selectedEventType === 'online'
    ? priceOfEventOnline
    : eventPrice}
</h2>

              <div className="tooltip-container">
                <p className='include-in-the-ticket' style={{ display: 'flex' }}>
                  <img src={infoIcon} alt="Info" className="speaker-icon" />
                  {t("whats_included")}
                </p>
                <div className="tooltip-text">
                  <div style={{ display: 'grid' }}>
                    <ul className='benefits-list-event'>
                      {listOfBenefits.map((benefit, index) => (
                        <li key={index} className='event-benefit'>
                          <img src={VerifiedIcon} alt="Verified" className="location-icon" />
                          {t(benefit)}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {isSoldOut ? (
            <SoldOutButton disabled>{t("sold_out")}</SoldOutButton>
          ) : (
          //   <Link
          //   style={{ textDecoration: 'none' }}
          //   to={selectedEventType === 'inPerson' && stripeLinkOnline ? stripeLinkOnline : stripeLink}
          // >
          //   <GradientButton2>{t(buttonText)}</GradientButton2>
          // </Link>
          <GradientButton2 onClick={() => setShowModal(true)}>
  {t(buttonText)}
</GradientButton2>
          

          )}
        </div>
      </div>
      {showModal && (
  <SelectPaymentModal
    stripeLink={stripeLink}
    kassaLink={kassaLink || ''}
    onClose={() => setShowModal(false)}
  />
)}

    </div>
  );
};

export default EventDetailsCard;
